<template>
  <V3MapFilter :active="value !== null" label="Round" @click="toggle(value)">
    <V3Button :active="[true].includes(value)" @click="toggle(true)"> Won </V3Button>
    <V3Button :active="[false].includes(value)" @click="toggle(false)"> Lost </V3Button>
  </V3MapFilter>
</template>

<script>
import px from 'vue-types'

import V3Button from '@/components/Map/components/v3dafi/V3Button.vue'
import { pxNullable } from '@/components/Map/types'

import V3MapFilter from '../v3dafi/V3MapFilter.vue'

export default {
  name: 'RoundWinFilter',
  components: {
    V3MapFilter,
    V3Button,
  },
  model: {
    event: 'change',
    prop: 'value',
  },
  props: {
    data: Object,
    selected: Object,
    value: pxNullable(px.bool),
  },
  methods: {
    toggle(value) {
      if (this.value !== value) {
        this.$emit('change', value)
      } else {
        this.$emit('change', null)
      }
    },
  },
}
</script>
